var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-ag-grid", {
    attrs: {
      "grid-options": _vm.gridOptions,
      "column-defs": _vm.columnDefs,
      "row-data": _vm.rowData
    },
    on: {
      gridReady: function(params) {
        _vm.gridApi = params.api
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }